import React from "react";
import styles from "./attribute-name-value.module.scss";

interface AttributeNameValueTypes {
  name: string;
  value: string;
}

export const AttributeNameValue = ({
  name,
  value,
}: AttributeNameValueTypes) => {
  const cssClassName = "attribute-name-value";

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__attribute-name`]}>{name}</div>
      <div className={styles[`${cssClassName}__attribute-value`]}>{value}</div>
    </div>
  );
};
